export default __webpack_public_path__ + "static/visao-kingdom-cc081180cea130a01dd72250a65d547f.png";